import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const ExpandIcon = ({ expanded, onClick = () => {}, className }) => (
  <div
    className={classnames(
      'expand-icon',
      className,
      { 'expand-icon--expanded': expanded }
    )}
    onClick={onClick}
  >
    <span className="expand-icon__item1" />
    <span className="expand-icon__item2" />
  </div>
);

ExpandIcon.propTypes = {
  expanded: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string
};

export default ExpandIcon;
